import React from 'react'
import { Link } from 'react-router-dom';

const Parallax = () => {
  return (
    <>
        <section className='parallax'>
            <div className='container'>
                <div className='row'>
                    <div className='col-full'>
                        <div className='parallax-content'>
                            <h4 className='subtitle-heading'>mid season's sale</h4>
                            <h2 className='main-heading'>Autumn collection upto 20% off</h2>
                            <div className='parallax-button'>
                                <Link to="/products" className="btn parallax-btn">Shop now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Parallax